import React from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import Cookies from "universal-cookie";
import getBackgrounds from "../services/getBackground";
import { NineCellLoading } from 'react-loadingg';
import { Grid } from "@material-ui/core";
import { ImagePicker } from 'react-file-picker';

export default class SelectBackgroundWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            isLoading: true,
            base64: undefined,
            isSmall: false, 
            isMobile: false,
        }
    }

    async componentDidMount() {
        window.addEventListener('resize', this.handleResize.bind(this));
        this.handleResize();
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.backgrounds = await getBackgrounds(username, token);
        this.addImg = this.backgrounds.filter((img) => img.id === '9')[0];
        this.setState({ isLoading: false, background: this.backgrounds, img: this.addImg.file});
    }

    handleResize() {
        if (window.innerWidth < 1280) {
            if (window.innerWidth < 970) {
                this.setState({ isSmall: false, isMobile: true });
            } else {
                this.setState({ isSmall: true, isMobile: false });
            }
        } else {
            this.setState({ isSmall: false, isMobile: false });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.handleResize());
    }

    render() {

        return ( 
        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
                <div style={container} onClick={() => this.props.onClose()}>
                <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                { !this.state.isLoading ? (
                    <div>
                        <div style={closeBtn} onClick={() => {
                            this.props.onClose();
                        }}>
                            <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                        </div>
                        <div style={windowTitle}>Seleziona uno sfondo per il menù</div>
                        <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: -5 }}>
                            <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                            <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>Seleziona uno degli sfondi proposti per il menù dell'app mobile, la grafica verrà aggiornata alla prossima riapertura.</p><br/>
                        </div>
                        <Grid container spacing={2} columns={{xs: 4}}>
                            { this.backgrounds.map((img, ind) => {
                                if (img.id !== '9') {
                                    return(
                                        <Grid key={Math.random()} item xs={this.state.isSmall ? 4 : this.state.isMobile ? 5 : 3}><img src={img.file} style={{ height: 250, width: 150, cursor: 'pointer', borderRadius: '5px', objectFir: 'cover' }} alt={'Sfondo ' + ind} onClick={() => { this.props.onDone(img.file, img.text_color); this.props.onClose(); }} /></Grid>
                                    );
                                }
                            })}
                        </Grid>
                        <ImagePicker
                            key={Math.random()}
                            extensions={['jpg', 'jpeg', 'png']}
                            dims={{minWidth: 100, maxWidth: 3000, minHeight: 100, maxHeight: 3000}}
                            onChange={base64 => {
                                this.setState({base64: base64});
                                this.props.onDone(base64, 'clear');
                                this.props.onClose();
                            }}
                            onError={() => { } } >
                                <div key={Math.random()} style={{
                                    backgroundImage: this.state.base64 !== undefined ? 'url("data:' + this.state.base64 + '")' : 'url("data:' + this.state.img + '")',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    width: '100%',
                                    minWidth: '100%',
                                    cursor: 'pointer',
                                    minHeight: '150px',
                                    maxHeight: '150px',
                                    marginTop: 20,
                                    border: '1px solid darkgrey',
                                    borderRadius: '10px',
                                    paddind: '5px',
                                    marginBottom: '10px',
                                    }} >
                                </div>
                        </ImagePicker>
                    </div>
                    ) : <NineCellLoading /> }
                </div>
                </div>
        </div>
        )
    }

}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    position: 'absolute',
    top: '100px',
    left: '25%', 
    width: '50%',
    height: '560px',
    background: 'white',
    padding: '2%', 
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const bodyMsg = {
    border: '1px solid black',
    height: '200px'
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}